
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItemExemptGrid extends Serenity.EntityGrid<PsAdvPromoItemExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItemExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItemExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItemExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItemExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItemExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItemExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}